var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 16v13.063c0 .248.105.487.293.662.187.176.442.275.707.275.265 0 .52-.099.707-.275a.909.909 0 00.293-.663V16h13.063a.909.909 0 00.662-.293c.176-.187.275-.442.275-.707 0-.265-.099-.52-.275-.707a.909.909 0 00-.663-.293H16V.937a.909.909 0 00-.293-.662A1.035 1.035 0 0015 0c-.265 0-.52.099-.707.275A.909.909 0 0014 .937V14H.937a.909.909 0 00-.662.293A1.035 1.035 0 000 15c0 .265.099.52.275.707A.909.909 0 00.937 16H14z"
  })));
}

export default SvgPlus;